import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Image } from '@elparking/components'
import { withTheme } from 'styled-components'

const IconContainer = ({ icon, size, theme, title }) => <Box width={size} minWidth={size} height={size} position='relative'>
    <Box position='absolute' width='100%' height='100%' >
        <svg width='100%' height='100%' viewBox='0 0 44 45' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M39.7982 22.7135C40.9386 27.0618 42.7232 27.5239 43.2646 29.4257C43.2646 29.4257 43.6498 30.7088 43.5945 31.5667C43.3569 35.3883 34.5942 43.6596 23.0551 44.0847C15.7869 44.3524 6.20845 41.1232 2.06665 31.7558C-2.05703 22.4253 2.06564 12.3394 7.94896 7.29696C13.9105 2.18761 23.7111 -0.804457 31.7785 1.94205C33.6446 2.57632 36.6542 3.60091 38.5268 6.19484C41.8139 10.7424 37.7009 14.7112 39.7982 22.7135Z'
              fill={theme.colors.accent20} />
        </svg>
    </Box>
    <Box position='absolute' width='100%' height='100%'>
        <Flex width='100%' height='100%' alignItems='center' textAlign='center' justifyContent='center'>
            <Image src={icon} alt={title}/>
        </Flex>
    </Box>
</Box>

IconContainer.propTypes = {
    icon: PropTypes.string,
    size: PropTypes.any,
    theme: PropTypes.object,
    title: PropTypes.string,
}

export default withTheme(IconContainer)
